import __request__ from "routing/request";
export function cancelAsyncSearchJob(jobId, nodeId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.views/views/searchjobs/${nodeId}/${jobId}/cancel`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function asyncSearchJobStatus(jobId, nodeId, page = 0, per_page = 0, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.views/views/searchjobs/${nodeId}/${jobId}/status`, null, { "page": page, "per_page": per_page }, {
    "Accept": [
      "application/json",
      "application/vnd.graylog.search.v1+json"
    ]
  }, requestOptions);
}
